export default __webpack_public_path__ + "static/media/fpah0200.906d4f77.png";